import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index";
import { saveBackupFilesRetentionPeriod, getBackupFilesRetentionPeriod } from "./systemSettingsService";

export default function BackupFilesSection() {

  const [days, setDaysPeriod] = useState('0');
  const { setPopup } = useContext(PopupContext);

  const isStartDisabled = false;

  const fetchData = async () => {
    try {
      let x = await getBackupFilesRetentionPeriod();
      setDaysPeriod(x.value);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetBackupFilesRetentionPeriodClick = event => {
    showInfoToast('Setting Backup Files Retention Period', 'Backup Files Retention');

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Backup Files Retention Period',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      saveBackupFilesRetentionPeriod(days);
    };
  };

  const changeDaysPeriod = (value) => { setDaysPeriod(value); }

  return (
    <>
      <div className="oct_settings-section-header" >
        <h3>Backup Files</h3>
      </div>

      <div className="oct_settings-section-body py-3">
        <p className="oct_settings-description">
          Backup Files stored before the Selected Days Period will be wiped permanently.
        </p>

        <div className="oct_settings-form-grid">
          <div className="oct_settings-field">
            <label className="oct_settings-label">Retention Period</label>
            <input
              className="oct_settings-input-v2"
              type="number"
              value={days}
              onChange={event => changeDaysPeriod(event.target.value)}
            />
          </div>
          <div className="oct_settings-field">
            <label className="oct_settings-label">Unit</label>
            <select className="oct_select-v2" disabled>
              <option value="Days">Days</option>
            </select>
          </div>
        </div>

        <button
          className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
          onClick={onSetBackupFilesRetentionPeriodClick}
        >
          Save Backup Files Retention Period
        </button>
      </div>
    </>
  );
}